export default __webpack_public_path__ + "static/media/services.704c46b3.svg";